module.exports = __webpack_public_path__ + "media/images/mailer/logo_full-7328865246241160c101e6441218a7a3.png";